$(document).on('click','#option-1.is-sub', function() {
  $( '.select-one' ).trigger('click');
});

$('.option-1').click(function(){
    $('.option-2').removeClass("active");
  $('.option-3').removeClass("active");
     	$('.option-1').addClass("active");
  $('.subbox.three').hide();
  $('.subbox.six').hide();
  $('.subbox.one').show();
  $( "#bonus60" ).prop( "disabled", true );
  $( "#bonus180" ).prop( "disabled", true );
        $('#rc_autodeliver_options select').val('30').change();
    $('#SingleOptionSelector-0').val('30 Day').change();
   $('#SingleOptionSelector-1').val('(1 Bottle) Original Blend').change();
});



$(document).on('click','#option-2.is-sub', function() {
  $( '.select-two' ).trigger('click');
});

$('.option-2').click(function(){
    $('.option-1').removeClass("active");
  $('.option-3').removeClass("active");
     	$('.option-2').addClass("active");
  $('.subbox.one').hide();
  $('.subbox.six').hide();
  $('.subbox.three').show();
   $( "#bonus60" ).prop( "disabled", false );
  $( "#bonus180" ).prop( "disabled", true );
        $('#rc_autodeliver_options select').val('90').change();
    $('#SingleOptionSelector-0').val('90 Day').change();
  $('#SingleOptionSelector-1').val('(3 Bottles) 3 Original Blend').change();
});



$(document).on('click','#option-3.is-sub', function() {
  $( '.select-three' ).trigger('click');
});


$('.option-3').click(function(){
    $('.option-1').removeClass("active");
  $('.option-2').removeClass("active");
     	$('.option-3').addClass("active");
  $('.subbox.one').hide();
  $('.subbox.three').hide();
  $('.subbox.six').show();
    $( "#bonus60" ).prop( "disabled", true );
  $( "#bonus180" ).prop( "disabled", false );
        $('#rc_autodeliver_options select').val('180').change();
    $('#SingleOptionSelector-0').val('180 Day').change();
   	$('#bonustitle').val('{{ oneeightyBonusTitleBonusTitle }}').change();
   $('#SingleOptionSelector-1').val('(6 Bottles) 6 Original Blend').change();
});




$(document).on('click','.subbox.one.active', function() {
  
    $('.optionbox').removeClass("is-sub"); 
  
    $('.subbox.one').removeClass("active");  
      $('.subbox').removeClass("active"); 
        $('.subbox').addClass("offline"); 
  $('#__product-subscription-info').hide();
     $('#__product-subscription-info').hide();
    $(".rc_label__onetime").trigger('click');
  
       $(".select-onetime").trigger('click');
  
  $('.__inno_product_purchase_btn').text("ADD TO CART");

});


$(document).on('click','.subbox.one.offline', function() {
  
     $('.optionbox').addClass("is-sub"); 
    $( '.select-one' ).trigger('click');
  
   $('.subbox').addClass("active");
        $('.subbox').removeClass("offline");
   $('#__product-subscription-info').show();
      $(".rc_label__autodeliver").trigger('click');
        $('#rc_autodeliver_options select').val('30').change();
    $('#SingleOptionSelector-0').val('30 Day').change();
  
   	
});



$(document).on('click','.subbox.three.active', function() {
  
     $('.optionbox').removeClass("is-sub"); 
  
    $('.subbox.one').removeClass("active");  
      $('.subbox').removeClass("active"); 
        $('.subbox').addClass("offline"); 
  $('#__product-subscription-info').hide();
     $('#__product-subscription-info').hide();
    $(".rc_label__onetime").trigger('click');
  
       $(".select-onetime").trigger('click');
  
  $('.__inno_product_purchase_btn').text("ADD TO CART");

});


$(document).on('click','.subbox.three.offline', function() {
  
       $('.optionbox').addClass("is-sub"); 
    $( '.select-two' ).trigger('click');
  
   $('.subbox').addClass("active");
        $('.subbox').removeClass("offline");
   $('#__product-subscription-info').show();
      $(".rc_label__autodeliver").trigger('click');
        $('#rc_autodeliver_options select').val('90').change();
    $('#SingleOptionSelector-0').val('90 Day').change();
  
   	
});
 




$(document).on('click','.subbox.six.active', function() {
  
     $('.optionbox').removeClass("is-sub"); 
  
    $('.subbox.six').removeClass("active");  
      $('.subbox').removeClass("active"); 
        $('.subbox').addClass("offline"); 
  $('#__product-subscription-info').hide();
     $('#__product-subscription-info').hide();
    $(".rc_label__onetime").trigger('click');
  
       $(".select-onetime").trigger('click');
  
  $('.__inno_product_purchase_btn').text("ADD TO CART");

});


$(document).on('click','.subbox.six.offline', function() {
  
       $('.optionbox').addClass("is-sub"); 
    $( '.select-three' ).trigger('click');
  
  
  
   $('.subbox').addClass("active");
        $('.subbox').removeClass("offline");
   $('#__product-subscription-info').show();
      $(".rc_label__autodeliver").trigger('click');
        $('#rc_autodeliver_options select').val('180').change();
    $('#SingleOptionSelector-0').val('180 Day').change();
  
   	
});



$('#SingleOptionSelector-1').change(function(){
  if($(this).val() == '(6 Bottles) 6 Original Blend'){ // or this.value == 'volvo'
    $(".option-3").trigger('click');
  }
   else if($(this).val() == '(6 Bottles) 6 Chocolate Caramel'){ // or this.value == 'volvo'
    $(".option-3").trigger('click');
  }
     else if($(this).val() == '(6 Bottles) 3 Original Blend, 3 Chocolate Caramel'){ // or this.value == 'volvo'
    $(".option-3").trigger('click');
  }
    else if($(this).val() == '(3 Bottles) 3 Original Blend'){ // or this.value == 'volvo'
    $(".option-2").trigger('click');
  }
    else if($(this).val() == '(3 Bottles) 2 Original Blend, 1 Chocolate Caramel'){ // or this.value == 'volvo'
    $(".option-2").trigger('click');
  }
    else if($(this).val() == '(3 Bottles) 2 Chocolate Caramel, 1 Original Blend'){ // or this.value == 'volvo'
    $(".option-2").trigger('click');
  }
    else if($(this).val() == '(3 Bottles) 3 Chocolate Caramel'){ // or this.value == 'volvo'
    $(".option-2").trigger('click');
  }
      else if($(this).val() == '(1 Bottle) Original Blend'){ // or this.value == 'volvo'
    $(".option-1").trigger('click');
  }
      else if($(this).val() == '(1 Bottle) Chocolate Caramel'){ // or this.value == 'volvo'
    $(".option-1").trigger('click');
  }
});


 $(window).on("load", function() {
     setTimeout(function() {
        $(".rc_label__autodeliver").trigger('click');
       $(".onetimez").trigger('click');

       
       $('#SingleOptionSelector-0').val('90 Day').change();
        $('#SingleOptionSelector-1').val('(3 Bottles) 3 Original Blend').change();
    },500);
   
   
});
  

 $(window).on("load", function() {
   if(performance.navigation.type == 2){
   location.reload(true);
};  
});


